import React, { useState, useEffect, useCallback } from "react";
import { DataTable } from "../../../../common";
import { IconMenuOption, ButtonView, Select } from "../../../../controls";
import Tooltip from "react-tooltip";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaFilter,
  FaPaste,
} from "react-icons/fa6";
import { MdDelete, MdClose, MdEdit } from "react-icons/md";

const YouTubeChannelsList = ({
  youtubeList,
  //
  youTubeSourceList,
  onClickChannelNameDropDownFilterOptions,
  persistedData,
  languages,
  onClickLanguageDropDownFilterOptions,
  onChangeCategory,
  onClickVideoCategoryAdd,
  status,
  userRole,
  Role,
  categoryDropDownOptions,
  onClickStatusDropDownFilterOptions,
  showSelection,
  isChannelNameOmitted,
  genreWithVideoId,
  categoryWithVideoId,
  setRowData,
  handleInitialGenresOfRow,
  showAddGenrePopup,
  showAddCategoryPopup,
  viewer,
  bulkPublishActionComponent,
  handleOnRowClicked,
  handleSelectedRows,
  selectableRowSelectedOnGenreChange,
  handleTableRowsChange,
  handleChangePage,
  currentPage,
  customStyles,
  conditionalRowStyles,
}) => {
  const renderTitle = (row) => {
    return (
      <div data-tag="allowRowEvents">
        <span
          className="cell-body-styles"
          data-tag="allowRowEvents"
          data-tip={row.title}
          data-for={`tooltip-title-${row._id}`}
        >
          {row?.title || "-"}
        </span>
        <Tooltip
          id={`tooltip-title-${row._id}`}
          place="top"
          effect="solid"
          type="dark"
          delayShow={500} // Delay in milliseconds
        >
          {/* {row?.title} */}
          <div className="tooltip-styles">{row.title ? row.title : "-"}</div>
        </Tooltip>
      </div>
    );
  };

  const renderChannelNameHeader = (label) => {
    return (
      <div className="custom-column-header">
        <text>{label}</text>
        {/* {userRole !== Role.Viewer && ( */}
        <div className="sortIcon">
          {!showSelection && (
            <IconMenuOption
              menuIcon={<FaFilter />}
              options={youTubeSourceList}
              name={"channelName"} //object contain "name" field ==> this is to access from iconMenuOption component
              search={false} //show search input
              showMenuOptions={true}
              onClickFilterOption={onClickChannelNameDropDownFilterOptions}
              persistedData={persistedData?.channel}
            />
          )}
        </div>
        {/* )} */}
      </div>
    );
  };

  const renderGenreNameHeader = (label) => {
    return (
      <div className="custom-column-header">
        <text>{label}</text>
      </div>
    );
  };

  const renderLanguageHeader = (label) => {
    return (
      <div className="custom-column-header">
        <text>{label}</text>
        <div className="sortIcon">
          {!showSelection && (
            <IconMenuOption
              menuIcon={<FaFilter />}
              options={languages}
              name={"name"} //object contain "name" field ==> this is to access from iconMenuOption component
              search={true} //show search input
              showMenuOptions={true}
              onClickFilterOption={onClickLanguageDropDownFilterOptions}
              persistedData={persistedData?.language}
            />
          )}
        </div>
      </div>
    );
  };

  const renderStatusHeader = (label) => {
    return (
      <div className="custom-column-header">
        <text>{label}</text>
        {userRole !== Role.Viewer && (
          <div className="sortIcon">
            {!showSelection && (
              <IconMenuOption
                menuIcon={<FaFilter />}
                options={status}
                name={"status"} //object contain "status" field ==> this is to access from iconMenuOption component
                showMenuOptions={true}
                onClickFilterOption={onClickStatusDropDownFilterOptions}
                persistedData={persistedData?.status}
              />
            )}
          </div>
        )}
      </div>
    );
  };

  const renderTagList = (row) => {
    const savedTags = row?.subCategory?.length > 0 ? row.subCategory : [];

    // Find the matching object in genreWithVideoId based on objectId
    const matchingTagObject = genreWithVideoId.find(
      (item) => item.objectId === row._id
    );

    if (matchingTagObject) {
      let genres = [...matchingTagObject.genres];

      // Extract genres as strings
      const tagsAsStrings = genres.map((tag) =>
        typeof tag === "object" ? tag.tag : tag
      );

      // Remove duplicates using Set
      const uniqueTags = [...new Set(tagsAsStrings)];

      // Render the unique genres as a comma-separated string
      return uniqueTags.length > 0 ? uniqueTags.join(", ") : "-";
    }

    // If there's no match, return the saved genres or "-"
    return savedTags.length > 0
      ? savedTags.map((tag) => tag.tag).join(", ")
      : "-";
  };

  const renderGenreColumnCell = (row) => {
    const renderTagListResult = renderTagList(row);

    return (
      <div className="tag-cell-wrapper d-flex">
        <span
          data-tag="allowRowEvents"
          className={`tags-block ${viewer || (!showSelection && "full-width")}`}
          data-tip={renderTagList(row)}
          data-for={`tooltip-tag-${row._id}`}
        >
          {renderTagList(row)}
        </span>
        <Tooltip
          id={`tooltip-tag-${row._id}`}
          place="top"
          effect="solid"
          delayShow={500} // Delay in milliseconds
        >
          {renderTagList(row)}
        </Tooltip>
        {!viewer && showSelection && (
          <span className="action-block">
            <ButtonView
              // title="Add Tag"
              // icon={<FaPlus />}
              icon={
                renderTagListResult === "-" ? (
                  <FaPlus title="Add genre" />
                ) : (
                  <MdEdit title="Edit genre" />
                )
              }
              styles={"light add-tag"}
              size={"small"}
              onClick={() => {
                setRowData(row);
                handleInitialGenresOfRow(row);
                showAddGenrePopup();
              }}
            />
          </span>
        )}
      </div>
    );
  };

  const renderCategoryHeader = (label) => {
    return (
      <div className="custom-column-header">
        <text>{label}</text>
        {/* {userRole !== Role.Viewer && ( */}
        <div className="sortIcon">
          {/* {!showSelection && (
            <IconMenuOption
              menuIcon={<FaFilter />}
              options={languages}
              name={"name"} //object contain "name" field ==> this is to access from iconMenuOption component
              search={true} //show search input
              showMenuOptions={true}
              onClickFilterOption={onClickLanguageDropDownFilterOptions}
              persistedData={persistedData?.language}
            />
          )} */}
        </div>
        {/* )} */}
      </div>
    );
  };

  // const renderCategoryList = (row) => {
  //   // Find the matching object in genreWithVideoId based on objectId
  //   const matchingCategoryObject = categoryWithVideoId?.find(
  //     (item) => item.objectId === row._id
  //   );

  //   if (matchingCategoryObject) {
  //     // Render the category as string
  //     return matchingCategoryObject?.category?.label || "-";
  //   }

  //   if (row?.contentType === "Shorts") {
  //     return "Shorts";
  //   }

  //   if (row?.categoryId?.categoryName) {
  //     return row.categoryId.categoryName;
  //   }

  //   return "-";
  // };

  // const renderCategoryColumnCell = (row) => {
  //   const renderTagListResult = renderCategoryList(row);

  //   return (
  //     <div className="tag-cell-wrapper d-flex">
  //       <span
  //         data-tag="allowRowEvents"
  //         className={`tags-block ${viewer || (!showSelection && "full-width")}`}
  //         data-tip={renderCategoryList(row)}
  //         data-for={`tooltip-tag-${row._id}`}
  //       >
  //         {renderCategoryList(row)}
  //       </span>
  //       {/* <Tooltip
  //         id={`tooltip-tag-${row._id}`}
  //         place="top"
  //         effect="solid"
  //         delayShow={500} // Delay in milliseconds
  //       >
  //         {renderCategoryList(row)}
  //       </Tooltip> */}
  //       {!viewer && showSelection && row?.contentType !== "Shorts" && (
  //         <span className="action-block">
  //           <ButtonView
  //             // title="Add Tag"
  //             // icon={<FaPlus />}
  //             icon={
  //               renderTagListResult === "-" ? (
  //                 <FaPlus title="Add category" />
  //               ) : (
  //                 <MdEdit title="Edit category" />
  //               )
  //             }
  //             styles={"light add-tag"}
  //             size={"small"}
  //             onClick={() => {
  //               setRowData(row);
  //               handleInitialGenresOfRow(row);
  //               showAddCategoryPopup();
  //             }}
  //           />
  //         </span>
  //       )}
  //     </div>
  //   );
  // };

  const renderCategoryList = (row) => {
    // Find the matching object in genreWithVideoId based on objectId
    const matchingCategoryObject = categoryWithVideoId?.find(
      (item) => item.objectId === row._id
    );

    let valueOfRowCategory;
    if (matchingCategoryObject) {
      valueOfRowCategory = categoryDropDownOptions?.filter(
        (item) => item?.label === matchingCategoryObject?.category?.label
      );
    } else {
      valueOfRowCategory = categoryDropDownOptions?.filter(
        (item) => item?.label === row?.categoryId?.categoryName
      );
    }

    if (row?.contentType === "Shorts") {
      return "Shorts";
    }

    // // return row.categoryId.categoryName;

    return (
      <div>
        <Select
          classNamePrefix={"category-menu-active"}
          value={valueOfRowCategory}
          placeholder={"Select Category"}
          options={categoryDropDownOptions}
          onChange={(val) => {
            console.log("val", val);
            onChangeCategory(val, () => {
              onClickVideoCategoryAdd(row); //pass row for identification
            });
          }}
          menuPortalTarget={document.body}
          menuPlacement="auto" // Automatically determines placement
        />
      </div>
    );
  };

  const renderCategoryColumnCell = (row) => {
    const renderCategoryListResult = renderCategoryList(row);

    return (
      <div className="tag-cell-wrapper d-flex">
        <span
          data-tag="allowRowEvents"
          className={`tags-block category ${
            viewer || (!showSelection && "full-width")
          }`}
          // data-tip={renderCategoryList(row)}
          // data-for={`tooltip-tag-${row._id}`}
        >
          {renderCategoryList(row)}
        </span>
        {/* <Tooltip
          id={`tooltip-tag-${row._id}`}
          place="top"
          effect="solid"
          delayShow={500} // Delay in milliseconds
        >
          {renderCategoryList(row)}
        </Tooltip> */}
        {/* {!viewer && showSelection && row?.contentType !== "Shorts" && (
          <span className="action-block">
            <ButtonView
              icon={
                renderCategoryListResult === "-" ? (
                  <FaPlus title="Add category" />
                ) : (
                  <MdEdit title="Edit category" />
                )
              }
              styles={"light add-tag"}
              size={"small"}
              onClick={() => {
                setRowData(row);
                // showAddCategoryPopup();
              }}
            />
          </span>
        )} */}
      </div>
    );
  };

  const columns = [
    {
      name: "Title",
      width: !showSelection
        ? isChannelNameOmitted
          ? "45%"
          : "25%"
        : isChannelNameOmitted
        ? "40%"
        : "21%",
      selector: (row) => renderTitle(row),
    },
    {
      name: renderChannelNameHeader("Channel Name"),
      center: false,
      omit: isChannelNameOmitted,
      width: "20%",
      selector: (row) => (row.channelTitle ? row.channelTitle : "-"),
    },
    {
      name: renderGenreNameHeader("Genre"),
      center: true,
      width: isChannelNameOmitted ? "20%" : "20%",
      cell: (row) => {
        return renderGenreColumnCell(row);
      },
    },
    {
      name: renderLanguageHeader("Language"),
      center: true,
      width: isChannelNameOmitted ? "20%" : "20%",
      selector: (row) => {
        return row && row.languageId && row.languageId
          ? row.languageId.name
          : "-";
      },
      omit: showSelection,
    },
    {
      name: renderCategoryHeader("Category"),
      center: true,
      width: "20%",
      cell: (row) => {
        return renderCategoryColumnCell(row);
      },
      omit: !showSelection,
    },
    {
      name: viewer ? "Status" : renderStatusHeader("Status"),
      width: !showSelection
        ? isChannelNameOmitted
          ? "15%"
          : "15%"
        : undefined,
      center: true,
      selector: (row) => row?.status[0]?.status || "-",
    },
  ];

  const programmaticallySelectedRows = useCallback(
    (row) => {
      return selectableRowSelectedOnGenreChange(row);
    },
    [genreWithVideoId, categoryWithVideoId]
  );

  return (
    <>
      <DataTable
        // extraStyles="data_table_extra-styles"
        columns={columns}
        data={youtubeList?.docs ? youtubeList?.docs : []}
        highlightOnHover={true}
        pointerOnHover={true}
        fixedHeader={true}
        persistTableHead={true}
        displayDescription={false}
        //
        displayActionButtonComponent={bulkPublishActionComponent()}
        // onRowClicked={(row) => !showSelection && handleOnRowClicked(row)}
        onRowClicked={(row) => handleOnRowClicked(row)}
        selectableRows={showSelection}
        selectableRowsVisibleOnly={true}
        clearSelectedRows={showSelection} //clear the header checkbox
        onSelectedRowsChange={(props) => handleSelectedRows(props)}
        selectableRowSelected={programmaticallySelectedRows} //programmatically select row when genres changed
        //
        pagination={true}
        paginationServer={true}
        paginationPerPage={youtubeList?.limit}
        paginationTotalRows={youtubeList?.totalDocs}
        onChangeRowsPerPage={handleTableRowsChange}
        onChangePage={handleChangePage}
        currentPage={currentPage}
        //
        customStyles={customStyles}
        conditionalRowStyles={conditionalRowStyles}
      />
    </>
  );
};

export default YouTubeChannelsList;
